import React from 'react';
import Landing from '../../components/landing/Landing';
import './HomePage.scss';


const HomePage = () => (
    <div className="home-page">
        <Landing />
    </div>
)

export default HomePage;